import { ArrowRight } from "lucide-react";

/**
 * PartnerInvitationSection — bottom-of-homepage CTA.
 *
 * Fixed wording for now (per 2026-10-10 trimmed scope). The CTA URL is a
 * single constant so it can be swapped later without touching layout.
 * This section cannot be removed by the partner.
 */
const CTA_URL = "https://eigooinc.net/discovery";

export default function PartnerInvitationSection() {
    return (
        <section
            data-testid="partner-invitation-section"
            className="relative bg-forest text-cream border-t border-cream/10"
        >
            <div className="max-w-5xl mx-auto px-5 md:px-10 py-16 md:py-20 text-center">
                <span className="divider-rule text-gold inline-block">
                    Partner Invitation
                </span>
                <h2
                    className="font-serif text-3xl md:text-5xl text-cream mt-5 leading-[1.1]"
                    data-testid="partner-invitation-heading"
                >
                    Thinking about starting or growing your own business?
                </h2>
                <p
                    className="mt-5 text-cream/70 text-sm md:text-base leading-relaxed max-w-2xl mx-auto"
                    data-testid="partner-invitation-body"
                >
                    Book a 60-minute discovery session with EIGOO. We'll walk through what your version of a brand platform could look like.
                </p>
                <div className="mt-8">
                    <a
                        href={CTA_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-pill btn-gold inline-flex items-center gap-2"
                        data-testid="partner-invitation-cta"
                    >
                        Book a Discovery Session
                        <ArrowRight size={14} />
                    </a>
                </div>
            </div>
        </section>
    );
}
